import { IconButton, mergeStyles } from '@fluentui/react';
import { FC } from 'react';
import { IUpdateUserProps } from '../resourceHelpers';

const iconButtonStyle = mergeStyles({
    margin: '0 auto',
});

interface UpdateUserProps extends IUpdateUserProps {
    onOpenModal: () => void;
}

export const UpdateUser: FC<UpdateUserProps> = ({ onOpenModal }) => {
    return <IconButton iconProps={{ iconName: 'Edit' }} title="Edit user" ariaLabel="Edit user" onClick={onOpenModal} className={iconButtonStyle} />;
};
